import { type ControllerApiConstructor } from './abstract'
import { AbstractSelfInitSdk } from './abstractSelfInit'
import { Catch } from './catchError'
import { BookingControllerApi, type Cart } from './generated'

export class CartSdk extends AbstractSelfInitSdk<BookingControllerApi> {
  protected getControllerApiConstructor(): ControllerApiConstructor<BookingControllerApi> {
    return BookingControllerApi
  }

  @Catch<Cart>()
  async getCart(withServices = true): Promise<Cart> {
    const response = await this.api.getCart(
      this.userSdk.getBffHeader(),
      withServices,
      this.userSdk.createAxiosOptions(),
    )

    return response.data
  }
}
